import "./style/coupon-popups.scss"
import React from "react"
import { CouponModalTrigger, CouponDetailsModal } from "@ng-mw/shared-react-components/coupons"
import { useSelector, useDispatch } from "react-redux"
import { RootState } from "@app/types"
import { hideCouponDetailsPopup } from "@app/store/app/appCreator"

const CouponPopups = () => {
    const dispatch = useDispatch<any>()
    const { visible, derivedCoupon } = useSelector(
        (state: RootState) => state.app.couponDetailsPopup,
    )
    const hideModal = () => dispatch(hideCouponDetailsPopup())
    return (
        <>
            <CouponModalTrigger modalBackground="primary" />
            <CouponDetailsModal
                visible={visible}
                coupon={derivedCoupon}
                hideModal={hideModal}
            />
        </>
    )
}

export default CouponPopups
